import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxSimilarDisallowedPositionsValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        if (stacking.isDisallowedPositionsUsed()) {
            const chosenStackedPlayersQuantity = this.getStackedPlayersQuantity();
            const allowedStackedPlayersQuantity = this.getAllowedStackedPlayersQuantity();

            if (chosenStackedPlayersQuantity > allowedStackedPlayersQuantity) {
                this.addError(
                    `Current configuration of disallowed positions does not allow stacking ${chosenStackedPlayersQuantity} players.`,
                );
            }
        }
    }

    private getStackedPlayersQuantity(): number {
        // @ts-ignore
        const {stacking} = this.dependencies;
        let quantity = stacking.getPlayersQuantityByGroupNumber(1);
        quantity += stacking.getPlayersQuantityByGroupNumber(2);
        return quantity;
    }

    private getAllowedStackedPlayersQuantity(): number {
        // @ts-ignore
        const {sportConfig} = this.dependencies;
        const intersectedPositionsQuantity = this._getIntersectedPositionsQuantity();
        const lineupPlayersQuantity = sportConfig.getPlayersInTeam();
        return lineupPlayersQuantity - intersectedPositionsQuantity;
    }

    _getIntersectedPositionsQuantity() {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const intersectedPositions = stacking.getIntersectedDisallowedPositions();
        return intersectedPositions.length;
    }
}

export default MaxSimilarDisallowedPositionsValidator;
